import { useMe } from '@/features/auth/hooks/useAuth'
import { userHasPermission } from '@/lib/permissions'

/**
 * May the signed-in person do this? A permission named as the catalogue names it
 * ('objects.create'), read from the /auth/me user - the same answer the route guard, the sidebar
 * and the server give (docs/rbac-permissions.md).
 *
 * Given several, true when the person holds ANY of them: the server lets either through for some
 * actions (an engineer's recovery.execute on their own assignment, or a manager's
 * recover-requests.update on any request).
 *
 * For hiding a control whose API would refuse, not for keeping anyone out: the server is the
 * boundary. False until /auth/me has answered, so a write button appears a moment late rather than
 * being offered to someone who will be refused.
 */
export function useCan(...permissions: string[]): boolean {
    const { data: me } = useMe()
    return permissions.some((permission) => userHasPermission(me, permission))
}
